webpackJsonp([156897593687669],{

/***/ 275:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2017 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg) && arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ }),

/***/ 353:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var has = Object.prototype.hasOwnProperty
	  , prefix = '~';
	
	/**
	 * Constructor to create a storage for our `EE` objects.
	 * An `Events` instance is a plain object whose properties are event names.
	 *
	 * @constructor
	 * @private
	 */
	function Events() {}
	
	//
	// We try to not inherit from `Object.prototype`. In some engines creating an
	// instance in this way is faster than calling `Object.create(null)` directly.
	// If `Object.create(null)` is not supported we prefix the event names with a
	// character to make sure that the built-in object properties are not
	// overridden or used as an attack vector.
	//
	if (Object.create) {
	  Events.prototype = Object.create(null);
	
	  //
	  // This hack is needed because the `__proto__` property is still inherited in
	  // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
	  //
	  if (!new Events().__proto__) prefix = false;
	}
	
	/**
	 * Representation of a single event listener.
	 *
	 * @param {Function} fn The listener function.
	 * @param {*} context The context to invoke the listener with.
	 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
	 * @constructor
	 * @private
	 */
	function EE(fn, context, once) {
	  this.fn = fn;
	  this.context = context;
	  this.once = once || false;
	}
	
	/**
	 * Add a listener for a given event.
	 *
	 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
	 * @param {(String|Symbol)} event The event name.
	 * @param {Function} fn The listener function.
	 * @param {*} context The context to invoke the listener with.
	 * @param {Boolean} once Specify if the listener is a one-time listener.
	 * @returns {EventEmitter}
	 * @private
	 */
	function addListener(emitter, event, fn, context, once) {
	  if (typeof fn !== 'function') {
	    throw new TypeError('The listener must be a function');
	  }
	
	  var listener = new EE(fn, context || emitter, once)
	    , evt = prefix ? prefix + event : event;
	
	  if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
	  else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
	  else emitter._events[evt] = [emitter._events[evt], listener];
	
	  return emitter;
	}
	
	/**
	 * Clear event by name.
	 *
	 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
	 * @param {(String|Symbol)} evt The Event name.
	 * @private
	 */
	function clearEvent(emitter, evt) {
	  if (--emitter._eventsCount === 0) emitter._events = new Events();
	  else delete emitter._events[evt];
	}
	
	/**
	 * Minimal `EventEmitter` interface that is molded against the Node.js
	 * `EventEmitter` interface.
	 *
	 * @constructor
	 * @public
	 */
	function EventEmitter() {
	  this._events = new Events();
	  this._eventsCount = 0;
	}
	
	/**
	 * Return an array listing the events for which the emitter has registered
	 * listeners.
	 *
	 * @returns {Array}
	 * @public
	 */
	EventEmitter.prototype.eventNames = function eventNames() {
	  var names = []
	    , events
	    , name;
	
	  if (this._eventsCount === 0) return names;
	
	  for (name in (events = this._events)) {
	    if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
	  }
	
	  if (Object.getOwnPropertySymbols) {
	    return names.concat(Object.getOwnPropertySymbols(events));
	  }
	
	  return names;
	};
	
	/**
	 * Return the listeners registered for a given event.
	 *
	 * @param {(String|Symbol)} event The event name.
	 * @returns {Array} The registered listeners.
	 * @public
	 */
	EventEmitter.prototype.listeners = function listeners(event) {
	  var evt = prefix ? prefix + event : event
	    , handlers = this._events[evt];
	
	  if (!handlers) return [];
	  if (handlers.fn) return [handlers.fn];
	
	  for (var i = 0, l = handlers.length, ee = new Array(l); i < l; i++) {
	    ee[i] = handlers[i].fn;
	  }
	
	  return ee;
	};
	
	/**
	 * Return the number of listeners listening to a given event.
	 *
	 * @param {(String|Symbol)} event The event name.
	 * @returns {Number} The number of listeners.
	 * @public
	 */
	EventEmitter.prototype.listenerCount = function listenerCount(event) {
	  var evt = prefix ? prefix + event : event
	    , listeners = this._events[evt];
	
	  if (!listeners) return 0;
	  if (listeners.fn) return 1;
	  return listeners.length;
	};
	
	/**
	 * Calls each of the listeners registered for a given event.
	 *
	 * @param {(String|Symbol)} event The event name.
	 * @returns {Boolean} `true` if the event had listeners, else `false`.
	 * @public
	 */
	EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
	  var evt = prefix ? prefix + event : event;
	
	  if (!this._events[evt]) return false;
	
	  var listeners = this._events[evt]
	    , len = arguments.length
	    , args
	    , i;
	
	  if (listeners.fn) {
	    if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
	
	    switch (len) {
	      case 1: return listeners.fn.call(listeners.context), true;
	      case 2: return listeners.fn.call(listeners.context, a1), true;
	      case 3: return listeners.fn.call(listeners.context, a1, a2), true;
	      case 4: return listeners.fn.call(listeners.context, a1, a2, a3), true;
	      case 5: return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
	      case 6: return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
	    }
	
	    for (i = 1, args = new Array(len -1); i < len; i++) {
	      args[i - 1] = arguments[i];
	    }
	
	    listeners.fn.apply(listeners.context, args);
	  } else {
	    var length = listeners.length
	      , j;
	
	    for (i = 0; i < length; i++) {
	      if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
	
	      switch (len) {
	        case 1: listeners[i].fn.call(listeners[i].context); break;
	        case 2: listeners[i].fn.call(listeners[i].context, a1); break;
	        case 3: listeners[i].fn.call(listeners[i].context, a1, a2); break;
	        case 4: listeners[i].fn.call(listeners[i].context, a1, a2, a3); break;
	        default:
	          if (!args) for (j = 1, args = new Array(len -1); j < len; j++) {
	            args[j - 1] = arguments[j];
	          }
	
	          listeners[i].fn.apply(listeners[i].context, args);
	      }
	    }
	  }
	
	  return true;
	};
	
	/**
	 * Add a listener for a given event.
	 *
	 * @param {(String|Symbol)} event The event name.
	 * @param {Function} fn The listener function.
	 * @param {*} [context=this] The context to invoke the listener with.
	 * @returns {EventEmitter} `this`.
	 * @public
	 */
	EventEmitter.prototype.on = function on(event, fn, context) {
	  return addListener(this, event, fn, context, false);
	};
	
	/**
	 * Add a one-time listener for a given event.
	 *
	 * @param {(String|Symbol)} event The event name.
	 * @param {Function} fn The listener function.
	 * @param {*} [context=this] The context to invoke the listener with.
	 * @returns {EventEmitter} `this`.
	 * @public
	 */
	EventEmitter.prototype.once = function once(event, fn, context) {
	  return addListener(this, event, fn, context, true);
	};
	
	/**
	 * Remove the listeners of a given event.
	 *
	 * @param {(String|Symbol)} event The event name.
	 * @param {Function} fn Only remove the listeners that match this function.
	 * @param {*} context Only remove the listeners that have this context.
	 * @param {Boolean} once Only remove one-time listeners.
	 * @returns {EventEmitter} `this`.
	 * @public
	 */
	EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
	  var evt = prefix ? prefix + event : event;
	
	  if (!this._events[evt]) return this;
	  if (!fn) {
	    clearEvent(this, evt);
	    return this;
	  }
	
	  var listeners = this._events[evt];
	
	  if (listeners.fn) {
	    if (
	      listeners.fn === fn &&
	      (!once || listeners.once) &&
	      (!context || listeners.context === context)
	    ) {
	      clearEvent(this, evt);
	    }
	  } else {
	    for (var i = 0, events = [], length = listeners.length; i < length; i++) {
	      if (
	        listeners[i].fn !== fn ||
	        (once && !listeners[i].once) ||
	        (context && listeners[i].context !== context)
	      ) {
	        events.push(listeners[i]);
	      }
	    }
	
	    //
	    // Reset the array, or remove it completely if we have no more listeners.
	    //
	    if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
	    else clearEvent(this, evt);
	  }
	
	  return this;
	};
	
	/**
	 * Remove all listeners, or those of the specified event.
	 *
	 * @param {(String|Symbol)} [event] The event name.
	 * @returns {EventEmitter} `this`.
	 * @public
	 */
	EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
	  var evt;
	
	  if (event) {
	    evt = prefix ? prefix + event : event;
	    if (this._events[evt]) clearEvent(this, evt);
	  } else {
	    this._events = new Events();
	    this._eventsCount = 0;
	  }
	
	  return this;
	};
	
	//
	// Alias methods names because people roll like that.
	//
	EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
	EventEmitter.prototype.addListener = EventEmitter.prototype.on;
	
	//
	// Expose the prefix.
	//
	EventEmitter.prefixed = prefix;
	
	//
	// Allow `EventEmitter` to be imported as module namespace.
	//
	EventEmitter.EventEmitter = EventEmitter;
	
	//
	// Expose the module.
	//
	if (true) {
	  module.exports = EventEmitter;
	}


/***/ }),

/***/ 608:
/***/ (function(module, exports, __webpack_require__) {

	/*!
	 * Jump.js 1.0.1 - A small, modern, dependency-free smooth scrolling library.
	 * Copyright (c) 2016 Michael Cavalea - https://github.com/callmecavs/jump.js
	 * License: MIT
	 */
	
	!function(o,n){ true?module.exports=n():"function"==typeof define&&define.amd?define(n):o.Jump=n()}(this,function(){"use strict";var o=function(o,n,e,t){return o/=t/2,o<1?e/2*o*o+n:(o--,-e/2*(o*(o-2)-1)+n)},n="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(o){return typeof o}:function(o){return o&&"function"==typeof Symbol&&o.constructor===Symbol?"symbol":typeof o},e=function(){function e(){return window.scrollY||window.pageYOffset}function t(o){return o.getBoundingClientRect().top+d}function i(o){v||(v=o),b=o-v,p=s(b,d,y,m),window.scrollTo(0,p),b<m?requestAnimationFrame(i):r()}function r(){window.scrollTo(0,d+y),c&&l&&(c.setAttribute("tabindex","-1"),c.focus()),"function"==typeof w&&w(),v=!1}function u(r){var u=arguments.length<=1||void 0===arguments[1]?{}:arguments[1];switch(m=u.duration||1e3,a=u.offset||0,w=u.callback,s=u.easing||o,l=u.a11y||!1,d=e(),"undefined"==typeof r?"undefined":n(r)){case"number":c=void 0,l=!1,f=d+r;break;case"object":c=r,f=t(c);break;case"string":c=document.querySelector(r),f=t(c)}switch(y=f-d+a,n(u.duration)){case"number":m=u.duration;break;case"function":m=u.duration(y)}requestAnimationFrame(i)}var c=void 0,d=void 0,f=void 0,a=void 0,s=void 0,l=void 0,y=void 0,m=void 0,v=void 0,b=void 0,p=void 0,w=void 0;return u},t=e();return t});

/***/ }),

/***/ 609:
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(30),
	    root = __webpack_require__(13);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView');
	
	module.exports = DataView;


/***/ }),

/***/ 610:
/***/ (function(module, exports, __webpack_require__) {

	var hashClear = __webpack_require__(648),
	    hashDelete = __webpack_require__(649),
	    hashGet = __webpack_require__(650),
	    hashHas = __webpack_require__(651),
	    hashSet = __webpack_require__(652);
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	module.exports = Hash;


/***/ }),

/***/ 83:
/***/ (function(module, exports, __webpack_require__) {

	var listCacheClear = __webpack_require__(659),
	    listCacheDelete = __webpack_require__(660),
	    listCacheGet = __webpack_require__(661),
	    listCacheHas = __webpack_require__(662),
	    listCacheSet = __webpack_require__(663);
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	module.exports = ListCache;


/***/ }),

/***/ 124:
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(30),
	    root = __webpack_require__(13);
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map');
	
	module.exports = Map;


/***/ }),

/***/ 611:
/***/ (function(module, exports, __webpack_require__) {

	var mapCacheClear = __webpack_require__(664),
	    mapCacheDelete = __webpack_require__(665),
	    mapCacheGet = __webpack_require__(666),
	    mapCacheHas = __webpack_require__(667),
	    mapCacheSet = __webpack_require__(668);
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	module.exports = MapCache;


/***/ }),

/***/ 612:
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(30),
	    root = __webpack_require__(13);
	
	/* Built-in method references that are verified to be native. */
	var Promise = getNative(root, 'Promise');
	
	module.exports = Promise;


/***/ }),

/***/ 613:
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(30),
	    root = __webpack_require__(13);
	
	/* Built-in method references that are verified to be native. */
	var Set = getNative(root, 'Set');
	
	module.exports = Set;


/***/ }),

/***/ 614:
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(83),
	    stackClear = __webpack_require__(675),
	    stackDelete = __webpack_require__(676),
	    stackGet = __webpack_require__(677),
	    stackHas = __webpack_require__(678),
	    stackSet = __webpack_require__(679);
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	module.exports = Stack;


/***/ }),

/***/ 125:
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(13);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ }),

/***/ 615:
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(13);
	
	/** Built-in value references. */
	var Uint8Array = root.Uint8Array;
	
	module.exports = Uint8Array;


/***/ }),

/***/ 616:
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(30),
	    root = __webpack_require__(13);
	
	/* Built-in method references that are verified to be native. */
	var WeakMap = getNative(root, 'WeakMap');
	
	module.exports = WeakMap;


/***/ }),

/***/ 617:
/***/ (function(module, exports) {

	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	module.exports = apply;


/***/ }),

/***/ 618:
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.forEach` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEach(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (iteratee(array[index], index, array) === false) {
	      break;
	    }
	  }
	  return array;
	}
	
	module.exports = arrayEach;


/***/ }),

/***/ 619:
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = arrayFilter;


/***/ }),

/***/ 192:
/***/ (function(module, exports, __webpack_require__) {

	var baseTimes = __webpack_require__(633),
	    isArguments = __webpack_require__(684),
	    isArray = __webpack_require__(133),
	    isBuffer = __webpack_require__(204),
	    isIndex = __webpack_require__(200),
	    isTypedArray = __webpack_require__(688);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = arrayLikeKeys;


/***/ }),

/***/ 193:
/***/ (function(module, exports) {

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	module.exports = arrayPush;


/***/ }),

/***/ 126:
/***/ (function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(194),
	    eq = __webpack_require__(132);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	module.exports = assignValue;


/***/ }),

/***/ 84:
/***/ (function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(132);
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	module.exports = assocIndexOf;


/***/ }),

/***/ 620:
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(58),
	    keys = __webpack_require__(89);
	
	/**
	 * The base implementation of `_.assign` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssign(object, source) {
	  return object && copyObject(source, keys(source), object);
	}
	
	module.exports = baseAssign;


/***/ }),

/***/ 621:
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(58),
	    keysIn = __webpack_require__(207);
	
	/**
	 * The base implementation of `_.assignIn` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssignIn(object, source) {
	  return object && copyObject(source, keysIn(source), object);
	}
	
	module.exports = baseAssignIn;


/***/ }),

/***/ 194:
/***/ (function(module, exports, __webpack_require__) {

	var defineProperty = __webpack_require__(196);
	
	/**
	 * The base implementation of `assignValue` and `assignMergeValue` without
	 * value checks.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function baseAssignValue(object, key, value) {
	  if (key == '__proto__' && defineProperty) {
	    defineProperty(object, key, {
	      'configurable': true,
	      'enumerable': true,
	      'value': value,
	      'writable': true
	    });
	  } else {
	    object[key] = value;
	  }
	}
	
	module.exports = baseAssignValue;


/***/ }),

/***/ 622:
/***/ (function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(614),
	    arrayEach = __webpack_require__(618),
	    assignValue = __webpack_require__(126),
	    baseAssign = __webpack_require__(620),
	    baseAssignIn = __webpack_require__(621),
	    cloneBuffer = __webpack_require__(634),
	    copyArray = __webpack_require__(639),
	    copySymbols = __webpack_require__(640),
	    copySymbolsIn = __webpack_require__(641),
	    getAllKeys = __webpack_require__(644),
	    getAllKeysIn = __webpack_require__(645),
	    getTag = __webpack_require__(130),
	    initCloneArray = __webpack_require__(653),
	    initCloneByTag = __webpack_require__(654),
	    initCloneObject = __webpack_require__(655),
	    isArray = __webpack_require__(133),
	    isBuffer = __webpack_require__(204),
	    isMap = __webpack_require__(685),
	    isObject = __webpack_require__(19),
	    isSet = __webpack_require__(686),
	    keys = __webpack_require__(89);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1,
	    CLONE_FLAT_FLAG = 2,
	    CLONE_SYMBOLS_FLAG = 4;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values supported by `_.clone`. */
	var cloneableTags = {};
	cloneableTags[argsTag] = cloneableTags[arrayTag] =
	cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	cloneableTags[boolTag] = cloneableTags[dateTag] =
	cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	cloneableTags[int32Tag] = cloneableTags[mapTag] =
	cloneableTags[numberTag] = cloneableTags[objectTag] =
	cloneableTags[regexpTag] = cloneableTags[setTag] =
	cloneableTags[stringTag] = cloneableTags[symbolTag] =
	cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	cloneableTags[errorTag] = cloneableTags[funcTag] =
	cloneableTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	 * traversed objects.
	 *
	 * @private
	 * @param {*} value The value to clone.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Deep clone
	 *  2 - Flatten inherited properties
	 *  4 - Clone symbols
	 * @param {Function} [customizer] The function to customize cloning.
	 * @param {string} [key] The key of `value`.
	 * @param {Object} [object] The parent object of `value`.
	 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	 * @returns {*} Returns the cloned value.
	 */
	function baseClone(value, bitmask, customizer, key, object, stack) {
	  var result,
	      isDeep = bitmask & CLONE_DEEP_FLAG,
	      isFlat = bitmask & CLONE_FLAT_FLAG,
	      isFull = bitmask & CLONE_SYMBOLS_FLAG;
	
	  if (customizer) {
	    result = object ? customizer(value, key, object, stack) : customizer(value);
	  }
	  if (result !== undefined) {
	    return result;
	  }
	  if (!isObject(value)) {
	    return value;
	  }
	  var isArr = isArray(value);
	  if (isArr) {
	    result = initCloneArray(value);
	    if (!isDeep) {
	      return copyArray(value, result);
	    }
	  } else {
	    var tag = getTag(value),
	        isFunc = tag == funcTag || tag == genTag;
	
	    if (isBuffer(value)) {
	      return cloneBuffer(value, isDeep);
	    }
	    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	      result = (isFlat || isFunc) ? {} : initCloneObject(value);
	      if (!isDeep) {
	        return isFlat
	          ? copySymbolsIn(value, baseAssignIn(result, value))
	          : copySymbols(value, baseAssign(result, value));
	      }
	    } else {
	      if (!cloneableTags[tag]) {
	        return object ? value : {};
	      }
	      result = initCloneByTag(value, tag, isDeep);
	    }
	  }
	  // Check for circular references and return its corresponding clone.
	  stack || (stack = new Stack);
	  var stacked = stack.get(value);
	  if (stacked) {
	    return stacked;
	  }
	  stack.set(value, result);
	
	  if (isSet(value)) {
	    value.forEach(function(subValue) {
	      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
	    });
	  } else if (isMap(value)) {
	    value.forEach(function(subValue, key) {
	      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
	    });
	  }
	
	  var keysFunc = isFull
	    ? (isFlat ? getAllKeysIn : getAllKeys)
	    : (isFlat ? keysIn : keys);
	
	  var props = isArr ? undefined : keysFunc(value);
	  arrayEach(props || value, function(subValue, key) {
	    if (props) {
	      key = subValue;
	      subValue = value[key];
	    }
	    // Recursively populate clone (susceptible to call stack limits).
	    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	  });
	  return result;
	}
	
	module.exports = baseClone;


/***/ }),

/***/ 623:
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(19);
	
	/** Built-in value references. */
	var objectCreate = Object.create;
	
	/**
	 * The base implementation of `_.create` without support for assigning
	 * properties to the created object.
	 *
	 * @private
	 * @param {Object} proto The object to inherit from.
	 * @returns {Object} Returns the new object.
	 */
	var baseCreate = (function() {
	  function object() {}
	  return function(proto) {
	    if (!isObject(proto)) {
	      return {};
	    }
	    if (objectCreate) {
	      return objectCreate(proto);
	    }
	    object.prototype = proto;
	    var result = new object;
	    object.prototype = undefined;
	    return result;
	  };
	}());
	
	module.exports = baseCreate;


/***/ }),

/***/ 195:
/***/ (function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(193),
	    isArray = __webpack_require__(133);
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	module.exports = baseGetAllKeys;


/***/ }),

/***/ 57:
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(125),
	    getRawTag = __webpack_require__(646),
	    objectToString = __webpack_require__(671);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ }),

/***/ 624:
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(57),
	    isObjectLike = __webpack_require__(42);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	module.exports = baseIsArguments;


/***/ }),

/***/ 625:
/***/ (function(module, exports, __webpack_require__) {

	var getTag = __webpack_require__(130),
	    isObjectLike = __webpack_require__(42);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]';
	
	/**
	 * The base implementation of `_.isMap` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	 */
	function baseIsMap(value) {
	  return isObjectLike(value) && getTag(value) == mapTag;
	}
	
	module.exports = baseIsMap;


/***/ }),

/***/ 626:
/***/ (function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(205),
	    isMasked = __webpack_require__(658),
	    isObject = __webpack_require__(19),
	    toSource = __webpack_require__(202);
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	module.exports = baseIsNative;


/***/ }),

/***/ 627:
/***/ (function(module, exports, __webpack_require__) {

	var getTag = __webpack_require__(130),
	    isObjectLike = __webpack_require__(42);
	
	/** `Object#toString` result references. */
	var setTag = '[object Set]';
	
	/**
	 * The base implementation of `_.isSet` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	 */
	function baseIsSet(value) {
	  return isObjectLike(value) && getTag(value) == setTag;
	}
	
	module.exports = baseIsSet;


/***/ }),

/***/ 628:
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(57),
	    isLength = __webpack_require__(206),
	    isObjectLike = __webpack_require__(42);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	module.exports = baseIsTypedArray;


/***/ }),

/***/ 629:
/***/ (function(module, exports, __webpack_require__) {

	var isPrototype = __webpack_require__(86),
	    nativeKeys = __webpack_require__(669);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeys;


/***/ }),

/***/ 630:
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(19),
	    isPrototype = __webpack_require__(86),
	    nativeKeysIn = __webpack_require__(670);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeysIn(object) {
	  if (!isObject(object)) {
	    return nativeKeysIn(object);
	  }
	  var isProto = isPrototype(object),
	      result = [];
	
	  for (var key in object) {
	    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeysIn;


/***/ }),

/***/ 631:
/***/ (function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(203),
	    overRest = __webpack_require__(672),
	    setToString = __webpack_require__(673);
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  return setToString(overRest(func, start, identity), func + '');
	}
	
	module.exports = baseRest;


/***/ }),

/***/ 632:
/***/ (function(module, exports, __webpack_require__) {

	var constant = __webpack_require__(682),
	    defineProperty = __webpack_require__(196),
	    identity = __webpack_require__(203);
	
	/**
	 * The base implementation of `setToString` without support for hot loop shorting.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var baseSetToString = !defineProperty ? identity : function(func, string) {
	  return defineProperty(func, 'toString', {
	    'configurable': true,
	    'enumerable': false,
	    'value': constant(string),
	    'writable': true
	  });
	};
	
	module.exports = baseSetToString;


/***/ }),

/***/ 633:
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	module.exports = baseTimes;


/***/ }),

/***/ 127:
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	module.exports = baseUnary;


/***/ }),

/***/ 128:
/***/ (function(module, exports, __webpack_require__) {

	var Uint8Array = __webpack_require__(615);
	
	/**
	 * Creates a clone of `arrayBuffer`.
	 *
	 * @private
	 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	 * @returns {ArrayBuffer} Returns the cloned array buffer.
	 */
	function cloneArrayBuffer(arrayBuffer) {
	  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	  return result;
	}
	
	module.exports = cloneArrayBuffer;


/***/ }),

/***/ 634:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(13);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined,
	    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
	
	/**
	 * Creates a clone of  `buffer`.
	 *
	 * @private
	 * @param {Buffer} buffer The buffer to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Buffer} Returns the cloned buffer.
	 */
	function cloneBuffer(buffer, isDeep) {
	  if (isDeep) {
	    return buffer.slice();
	  }
	  var length = buffer.length,
	      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	  buffer.copy(result);
	  return result;
	}
	
	module.exports = cloneBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(32)(module)))

/***/ }),

/***/ 635:
/***/ (function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(128);
	
	/**
	 * Creates a clone of `dataView`.
	 *
	 * @private
	 * @param {Object} dataView The data view to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned data view.
	 */
	function cloneDataView(dataView, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	}
	
	module.exports = cloneDataView;


/***/ }),

/***/ 636:
/***/ (function(module, exports) {

	/** Used to match `RegExp` flags from their coerced string values. */
	var reFlags = /\w*$/;
	
	/**
	 * Creates a clone of `regexp`.
	 *
	 * @private
	 * @param {Object} regexp The regexp to clone.
	 * @returns {Object} Returns the cloned regexp.
	 */
	function cloneRegExp(regexp) {
	  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	  result.lastIndex = regexp.lastIndex;
	  return result;
	}
	
	module.exports = cloneRegExp;


/***/ }),

/***/ 637:
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(125);
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * Creates a clone of the `symbol` object.
	 *
	 * @private
	 * @param {Object} symbol The symbol object to clone.
	 * @returns {Object} Returns the cloned symbol object.
	 */
	function cloneSymbol(symbol) {
	  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	}
	
	module.exports = cloneSymbol;


/***/ }),

/***/ 638:
/***/ (function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(128);
	
	/**
	 * Creates a clone of `typedArray`.
	 *
	 * @private
	 * @param {Object} typedArray The typed array to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned typed array.
	 */
	function cloneTypedArray(typedArray, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	}
	
	module.exports = cloneTypedArray;


/***/ }),

/***/ 639:
/***/ (function(module, exports) {

	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function copyArray(source, array) {
	  var index = -1,
	      length = source.length;
	
	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}
	
	module.exports = copyArray;


/***/ }),

/***/ 58:
/***/ (function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(126),
	    baseAssignValue = __webpack_require__(194);
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  var isNew = !object;
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	
	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : undefined;
	
	    if (newValue === undefined) {
	      newValue = source[key];
	    }
	    if (isNew) {
	      baseAssignValue(object, key, newValue);
	    } else {
	      assignValue(object, key, newValue);
	    }
	  }
	  return object;
	}
	
	module.exports = copyObject;


/***/ }),

/***/ 640:
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(58),
	    getSymbols = __webpack_require__(129);
	
	/**
	 * Copies own symbols of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbols(source, object) {
	  return copyObject(source, getSymbols(source), object);
	}
	
	module.exports = copySymbols;


/***/ }),

/***/ 641:
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(58),
	    getSymbolsIn = __webpack_require__(199);
	
	/**
	 * Copies own and inherited symbols of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbolsIn(source, object) {
	  return copyObject(source, getSymbolsIn(source), object);
	}
	
	module.exports = copySymbolsIn;


/***/ }),

/***/ 642:
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(13);
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	module.exports = coreJsData;


/***/ }),

/***/ 643:
/***/ (function(module, exports, __webpack_require__) {

	var baseRest = __webpack_require__(631),
	    isIterateeCall = __webpack_require__(656);
	
	/**
	 * Creates a function like `_.assign`.
	 *
	 * @private
	 * @param {Function} assigner The function to assign values.
	 * @returns {Function} Returns the new assigner function.
	 */
	function createAssigner(assigner) {
	  return baseRest(function(object, sources) {
	    var index = -1,
	        length = sources.length,
	        customizer = length > 1 ? sources[length - 1] : undefined,
	        guard = length > 2 ? sources[2] : undefined;
	
	    customizer = (assigner.length > 3 && typeof customizer == 'function')
	      ? (length--, customizer)
	      : undefined;
	
	    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	      customizer = length < 3 ? undefined : customizer;
	      length = 1;
	    }
	    object = Object(object);
	    while (++index < length) {
	      var source = sources[index];
	      if (source) {
	        assigner(object, source, index, customizer);
	      }
	    }
	    return object;
	  });
	}
	
	module.exports = createAssigner;


/***/ }),

/***/ 196:
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(30);
	
	var defineProperty = (function() {
	  try {
	    var func = getNative(Object, 'defineProperty');
	    func({}, '', {});
	    return func;
	  } catch (e) {}
	}());
	
	module.exports = defineProperty;


/***/ }),

/***/ 197:
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 644:
/***/ (function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(195),
	    getSymbols = __webpack_require__(129),
	    keys = __webpack_require__(89);
	
	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}
	
	module.exports = getAllKeys;


/***/ }),

/***/ 645:
/***/ (function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(195),
	    getSymbolsIn = __webpack_require__(199),
	    keysIn = __webpack_require__(207);
	
	/**
	 * Creates an array of own and inherited enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeysIn(object) {
	  return baseGetAllKeys(object, keysIn, getSymbolsIn);
	}
	
	module.exports = getAllKeysIn;


/***/ }),

/***/ 85:
/***/ (function(module, exports, __webpack_require__) {

	var isKeyable = __webpack_require__(657);
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	module.exports = getMapData;


/***/ }),

/***/ 30:
/***/ (function(module, exports, __webpack_require__) {

	var baseIsNative = __webpack_require__(626),
	    getValue = __webpack_require__(647);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ }),

/***/ 198:
/***/ (function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(201);
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	module.exports = getPrototype;


/***/ }),

/***/ 646:
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(125);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ }),

/***/ 129:
/***/ (function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(619),
	    stubArray = __webpack_require__(208);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	  if (object == null) {
	    return [];
	  }
	  object = Object(object);
	  return arrayFilter(nativeGetSymbols(object), function(symbol) {
	    return propertyIsEnumerable.call(object, symbol);
	  });
	};
	
	module.exports = getSymbols;


/***/ }),

/***/ 199:
/***/ (function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(193),
	    getPrototype = __webpack_require__(198),
	    getSymbols = __webpack_require__(129),
	    stubArray = __webpack_require__(208);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own and inherited enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	  var result = [];
	  while (object) {
	    arrayPush(result, getSymbols(object));
	    object = getPrototype(object);
	  }
	  return result;
	};
	
	module.exports = getSymbolsIn;


/***/ }),

/***/ 130:
/***/ (function(module, exports, __webpack_require__) {

	var DataView = __webpack_require__(609),
	    Map = __webpack_require__(124),
	    Promise = __webpack_require__(612),
	    Set = __webpack_require__(613),
	    WeakMap = __webpack_require__(616),
	    baseGetTag = __webpack_require__(57),
	    toSource = __webpack_require__(202);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag = '[object Set]',
	    weakMapTag = '[object WeakMap]';
	
	var dataViewTag = '[object DataView]';
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = baseGetTag(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : '';
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	module.exports = getTag;


/***/ }),

/***/ 647:
/***/ (function(module, exports) {

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	module.exports = getValue;


/***/ }),

/***/ 648:
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(87);
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	module.exports = hashClear;


/***/ }),

/***/ 649:
/***/ (function(module, exports) {

	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = hashDelete;


/***/ }),

/***/ 650:
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(87);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	module.exports = hashGet;


/***/ }),

/***/ 651:
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(87);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}
	
	module.exports = hashHas;


/***/ }),

/***/ 652:
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(87);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	module.exports = hashSet;


/***/ }),

/***/ 653:
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Initializes an array clone.
	 *
	 * @private
	 * @param {Array} array The array to clone.
	 * @returns {Array} Returns the initialized clone.
	 */
	function initCloneArray(array) {
	  var length = array.length,
	      result = new array.constructor(length);
	
	  // Add properties assigned by `RegExp#exec`.
	  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	    result.index = array.index;
	    result.input = array.input;
	  }
	  return result;
	}
	
	module.exports = initCloneArray;


/***/ }),

/***/ 654:
/***/ (function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(128),
	    cloneDataView = __webpack_require__(635),
	    cloneRegExp = __webpack_require__(636),
	    cloneSymbol = __webpack_require__(637),
	    cloneTypedArray = __webpack_require__(638);
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/**
	 * Initializes an object clone based on its `toStringTag`.
	 *
	 * **Note:** This function only supports cloning values with tags of
	 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @param {string} tag The `toStringTag` of the object to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneByTag(object, tag, isDeep) {
	  var Ctor = object.constructor;
	  switch (tag) {
	    case arrayBufferTag:
	      return cloneArrayBuffer(object);
	
	    case boolTag:
	    case dateTag:
	      return new Ctor(+object);
	
	    case dataViewTag:
	      return cloneDataView(object, isDeep);
	
	    case float32Tag: case float64Tag:
	    case int8Tag: case int16Tag: case int32Tag:
	    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	      return cloneTypedArray(object, isDeep);
	
	    case mapTag:
	      return new Ctor;
	
	    case numberTag:
	    case stringTag:
	      return new Ctor(object);
	
	    case regexpTag:
	      return cloneRegExp(object);
	
	    case setTag:
	      return new Ctor;
	
	    case symbolTag:
	      return cloneSymbol(object);
	  }
	}
	
	module.exports = initCloneByTag;


/***/ }),

/***/ 655:
/***/ (function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(623),
	    getPrototype = __webpack_require__(198),
	    isPrototype = __webpack_require__(86);
	
	/**
	 * Initializes an object clone.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneObject(object) {
	  return (typeof object.constructor == 'function' && !isPrototype(object))
	    ? baseCreate(getPrototype(object))
	    : {};
	}
	
	module.exports = initCloneObject;


/***/ }),

/***/ 200:
/***/ (function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  var type = typeof value;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	
	  return !!length &&
	    (type == 'number' ||
	      (type != 'symbol' && reIsUint.test(value))) &&
	        (value > -1 && value % 1 == 0 && value < length);
	}
	
	module.exports = isIndex;


/***/ }),

/***/ 656:
/***/ (function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(132),
	    isArrayLike = __webpack_require__(88),
	    isIndex = __webpack_require__(200),
	    isObject = __webpack_require__(19);
	
	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}
	
	module.exports = isIterateeCall;


/***/ }),

/***/ 657:
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	module.exports = isKeyable;


/***/ }),

/***/ 658:
/***/ (function(module, exports, __webpack_require__) {

	var coreJsData = __webpack_require__(642);
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	module.exports = isMasked;


/***/ }),

/***/ 86:
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	module.exports = isPrototype;


/***/ }),

/***/ 659:
/***/ (function(module, exports) {

	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	module.exports = listCacheClear;


/***/ }),

/***/ 660:
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(84);
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	module.exports = listCacheDelete;


/***/ }),

/***/ 661:
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(84);
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	module.exports = listCacheGet;


/***/ }),

/***/ 662:
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(84);
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	module.exports = listCacheHas;


/***/ }),

/***/ 663:
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(84);
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	module.exports = listCacheSet;


/***/ }),

/***/ 664:
/***/ (function(module, exports, __webpack_require__) {

	var Hash = __webpack_require__(610),
	    ListCache = __webpack_require__(83),
	    Map = __webpack_require__(124);
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	module.exports = mapCacheClear;


/***/ }),

/***/ 665:
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(85);
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = mapCacheDelete;


/***/ }),

/***/ 666:
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(85);
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	module.exports = mapCacheGet;


/***/ }),

/***/ 667:
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(85);
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	module.exports = mapCacheHas;


/***/ }),

/***/ 668:
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(85);
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	module.exports = mapCacheSet;


/***/ }),

/***/ 87:
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(30);
	
	/* Built-in method references that are verified to be native. */
	var nativeCreate = getNative(Object, 'create');
	
	module.exports = nativeCreate;


/***/ }),

/***/ 669:
/***/ (function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(201);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	module.exports = nativeKeys;


/***/ }),

/***/ 670:
/***/ (function(module, exports) {

	/**
	 * This function is like
	 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * except that it includes inherited enumerable properties.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function nativeKeysIn(object) {
	  var result = [];
	  if (object != null) {
	    for (var key in Object(object)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = nativeKeysIn;


/***/ }),

/***/ 131:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(197);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    // Use `util.types` for Node.js 10+.
	    var types = freeModule && freeModule.require && freeModule.require('util').types;
	
	    if (types) {
	      return types;
	    }
	
	    // Legacy `process.binding('util')` for Node.js < 10.
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	module.exports = nodeUtil;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(32)(module)))

/***/ }),

/***/ 671:
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ }),

/***/ 201:
/***/ (function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ }),

/***/ 672:
/***/ (function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(617);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * A specialized version of `baseRest` which transforms the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @param {Function} transform The rest array transform.
	 * @returns {Function} Returns the new function.
	 */
	function overRest(func, start, transform) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = transform(array);
	    return apply(func, this, otherArgs);
	  };
	}
	
	module.exports = overRest;


/***/ }),

/***/ 13:
/***/ (function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(197);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ }),

/***/ 673:
/***/ (function(module, exports, __webpack_require__) {

	var baseSetToString = __webpack_require__(632),
	    shortOut = __webpack_require__(674);
	
	/**
	 * Sets the `toString` method of `func` to return `string`.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var setToString = shortOut(baseSetToString);
	
	module.exports = setToString;


/***/ }),

/***/ 674:
/***/ (function(module, exports) {

	/** Used to detect hot functions by number of calls within a span of milliseconds. */
	var HOT_COUNT = 800,
	    HOT_SPAN = 16;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeNow = Date.now;
	
	/**
	 * Creates a function that'll short out and invoke `identity` instead
	 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	 * milliseconds.
	 *
	 * @private
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new shortable function.
	 */
	function shortOut(func) {
	  var count = 0,
	      lastCalled = 0;
	
	  return function() {
	    var stamp = nativeNow(),
	        remaining = HOT_SPAN - (stamp - lastCalled);
	
	    lastCalled = stamp;
	    if (remaining > 0) {
	      if (++count >= HOT_COUNT) {
	        return arguments[0];
	      }
	    } else {
	      count = 0;
	    }
	    return func.apply(undefined, arguments);
	  };
	}
	
	module.exports = shortOut;


/***/ }),

/***/ 675:
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(83);
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}
	
	module.exports = stackClear;


/***/ }),

/***/ 676:
/***/ (function(module, exports) {

	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);
	
	  this.size = data.size;
	  return result;
	}
	
	module.exports = stackDelete;


/***/ }),

/***/ 677:
/***/ (function(module, exports) {

	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	module.exports = stackGet;


/***/ }),

/***/ 678:
/***/ (function(module, exports) {

	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	module.exports = stackHas;


/***/ }),

/***/ 679:
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(83),
	    Map = __webpack_require__(124),
	    MapCache = __webpack_require__(611);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}
	
	module.exports = stackSet;


/***/ }),

/***/ 202:
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var funcProto = Function.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	module.exports = toSource;


/***/ }),

/***/ 680:
/***/ (function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(126),
	    copyObject = __webpack_require__(58),
	    createAssigner = __webpack_require__(643),
	    isArrayLike = __webpack_require__(88),
	    isPrototype = __webpack_require__(86),
	    keys = __webpack_require__(89);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Assigns own enumerable string keyed properties of source objects to the
	 * destination object. Source objects are applied from left to right.
	 * Subsequent sources overwrite property assignments of previous sources.
	 *
	 * **Note:** This method mutates `object` and is loosely based on
	 * [`Object.assign`](https://mdn.io/Object/assign).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.10.0
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @see _.assignIn
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * function Bar() {
	 *   this.c = 3;
	 * }
	 *
	 * Foo.prototype.b = 2;
	 * Bar.prototype.d = 4;
	 *
	 * _.assign({ 'a': 0 }, new Foo, new Bar);
	 * // => { 'a': 1, 'c': 3 }
	 */
	var assign = createAssigner(function(object, source) {
	  if (isPrototype(source) || isArrayLike(source)) {
	    copyObject(source, keys(source), object);
	    return;
	  }
	  for (var key in source) {
	    if (hasOwnProperty.call(source, key)) {
	      assignValue(object, key, source[key]);
	    }
	  }
	});
	
	module.exports = assign;


/***/ }),

/***/ 681:
/***/ (function(module, exports, __webpack_require__) {

	var baseClone = __webpack_require__(622);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_SYMBOLS_FLAG = 4;
	
	/**
	 * Creates a shallow clone of `value`.
	 *
	 * **Note:** This method is loosely based on the
	 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
	 * and supports cloning arrays, array buffers, booleans, date objects, maps,
	 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
	 * arrays. The own enumerable properties of `arguments` objects are cloned
	 * as plain objects. An empty object is returned for uncloneable values such
	 * as error objects, functions, DOM nodes, and WeakMaps.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to clone.
	 * @returns {*} Returns the cloned value.
	 * @see _.cloneDeep
	 * @example
	 *
	 * var objects = [{ 'a': 1 }, { 'b': 2 }];
	 *
	 * var shallow = _.clone(objects);
	 * console.log(shallow[0] === objects[0]);
	 * // => true
	 */
	function clone(value) {
	  return baseClone(value, CLONE_SYMBOLS_FLAG);
	}
	
	module.exports = clone;


/***/ }),

/***/ 682:
/***/ (function(module, exports) {

	/**
	 * Creates a function that returns `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {*} value The value to return from the new function.
	 * @returns {Function} Returns the new constant function.
	 * @example
	 *
	 * var objects = _.times(2, _.constant({ 'a': 1 }));
	 *
	 * console.log(objects);
	 * // => [{ 'a': 1 }, { 'a': 1 }]
	 *
	 * console.log(objects[0] === objects[1]);
	 * // => true
	 */
	function constant(value) {
	  return function() {
	    return value;
	  };
	}
	
	module.exports = constant;


/***/ }),

/***/ 683:
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(19),
	    now = __webpack_require__(691),
	    toNumber = __webpack_require__(694);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        timeWaiting = wait - timeSinceLastCall;
	
	    return maxing
	      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
	      : timeWaiting;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        clearTimeout(timerId);
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	module.exports = debounce;


/***/ }),

/***/ 132:
/***/ (function(module, exports) {

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	module.exports = eq;


/***/ }),

/***/ 203:
/***/ (function(module, exports) {

	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;


/***/ }),

/***/ 684:
/***/ (function(module, exports, __webpack_require__) {

	var baseIsArguments = __webpack_require__(624),
	    isObjectLike = __webpack_require__(42);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	module.exports = isArguments;


/***/ }),

/***/ 133:
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	module.exports = isArray;


/***/ }),

/***/ 88:
/***/ (function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(205),
	    isLength = __webpack_require__(206);
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	module.exports = isArrayLike;


/***/ }),

/***/ 204:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(13),
	    stubFalse = __webpack_require__(692);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	module.exports = isBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(32)(module)))

/***/ }),

/***/ 205:
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(57),
	    isObject = __webpack_require__(19);
	
	/** `Object#toString` result references. */
	var asyncTag = '[object AsyncFunction]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    proxyTag = '[object Proxy]';
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	module.exports = isFunction;


/***/ }),

/***/ 206:
/***/ (function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ }),

/***/ 685:
/***/ (function(module, exports, __webpack_require__) {

	var baseIsMap = __webpack_require__(625),
	    baseUnary = __webpack_require__(127),
	    nodeUtil = __webpack_require__(131);
	
	/* Node.js helper references. */
	var nodeIsMap = nodeUtil && nodeUtil.isMap;
	
	/**
	 * Checks if `value` is classified as a `Map` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	 * @example
	 *
	 * _.isMap(new Map);
	 * // => true
	 *
	 * _.isMap(new WeakMap);
	 * // => false
	 */
	var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
	
	module.exports = isMap;


/***/ }),

/***/ 19:
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ }),

/***/ 42:
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ }),

/***/ 686:
/***/ (function(module, exports, __webpack_require__) {

	var baseIsSet = __webpack_require__(627),
	    baseUnary = __webpack_require__(127),
	    nodeUtil = __webpack_require__(131);
	
	/* Node.js helper references. */
	var nodeIsSet = nodeUtil && nodeUtil.isSet;
	
	/**
	 * Checks if `value` is classified as a `Set` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	 * @example
	 *
	 * _.isSet(new Set);
	 * // => true
	 *
	 * _.isSet(new WeakSet);
	 * // => false
	 */
	var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
	
	module.exports = isSet;


/***/ }),

/***/ 687:
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(57),
	    isObjectLike = __webpack_require__(42);
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && baseGetTag(value) == symbolTag);
	}
	
	module.exports = isSymbol;


/***/ }),

/***/ 688:
/***/ (function(module, exports, __webpack_require__) {

	var baseIsTypedArray = __webpack_require__(628),
	    baseUnary = __webpack_require__(127),
	    nodeUtil = __webpack_require__(131);
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	module.exports = isTypedArray;


/***/ }),

/***/ 89:
/***/ (function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(192),
	    baseKeys = __webpack_require__(629),
	    isArrayLike = __webpack_require__(88);
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	module.exports = keys;


/***/ }),

/***/ 207:
/***/ (function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(192),
	    baseKeysIn = __webpack_require__(630),
	    isArrayLike = __webpack_require__(88);
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	}
	
	module.exports = keysIn;


/***/ }),

/***/ 690:
/***/ (function(module, exports) {

	/**
	 * This method returns `undefined`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.3.0
	 * @category Util
	 * @example
	 *
	 * _.times(2, _.noop);
	 * // => [undefined, undefined]
	 */
	function noop() {
	  // No operation performed.
	}
	
	module.exports = noop;


/***/ }),

/***/ 691:
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(13);
	
	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function() {
	  return root.Date.now();
	};
	
	module.exports = now;


/***/ }),

/***/ 208:
/***/ (function(module, exports) {

	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	module.exports = stubArray;


/***/ }),

/***/ 692:
/***/ (function(module, exports) {

	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = stubFalse;


/***/ }),

/***/ 693:
/***/ (function(module, exports, __webpack_require__) {

	var debounce = __webpack_require__(683),
	    isObject = __webpack_require__(19);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a throttled function that only invokes `func` at most once per
	 * every `wait` milliseconds. The throttled function comes with a `cancel`
	 * method to cancel delayed `func` invocations and a `flush` method to
	 * immediately invoke them. Provide `options` to indicate whether `func`
	 * should be invoked on the leading and/or trailing edge of the `wait`
	 * timeout. The `func` is invoked with the last arguments provided to the
	 * throttled function. Subsequent calls to the throttled function return the
	 * result of the last `func` invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the throttled function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.throttle` and `_.debounce`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to throttle.
	 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=true]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new throttled function.
	 * @example
	 *
	 * // Avoid excessively updating the position while scrolling.
	 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	 *
	 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	 * jQuery(element).on('click', throttled);
	 *
	 * // Cancel the trailing throttled invocation.
	 * jQuery(window).on('popstate', throttled.cancel);
	 */
	function throttle(func, wait, options) {
	  var leading = true,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  if (isObject(options)) {
	    leading = 'leading' in options ? !!options.leading : leading;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	  return debounce(func, wait, {
	    'leading': leading,
	    'maxWait': wait,
	    'trailing': trailing
	  });
	}
	
	module.exports = throttle;


/***/ }),

/***/ 694:
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(19),
	    isSymbol = __webpack_require__(687);
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = toNumber;


/***/ }),

/***/ 696:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
	(function() {
	  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;
	
	  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
	    module.exports = function() {
	      return performance.now();
	    };
	  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
	    module.exports = function() {
	      return (getNanoSeconds() - nodeLoadTime) / 1e6;
	    };
	    hrtime = process.hrtime;
	    getNanoSeconds = function() {
	      var hr;
	      hr = hrtime();
	      return hr[0] * 1e9 + hr[1];
	    };
	    moduleLoadTime = getNanoSeconds();
	    upTime = process.uptime() * 1e9;
	    nodeLoadTime = moduleLoadTime - upTime;
	  } else if (Date.now) {
	    module.exports = function() {
	      return Date.now() - loadTime;
	    };
	    loadTime = Date.now();
	  } else {
	    module.exports = function() {
	      return new Date().getTime() - loadTime;
	    };
	    loadTime = new Date().getTime();
	  }
	
	}).call(this);
	
	//# sourceMappingURL=performance-now.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25)))

/***/ }),

/***/ 700:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(696)
	  , root = typeof window === 'undefined' ? global : window
	  , vendors = ['moz', 'webkit']
	  , suffix = 'AnimationFrame'
	  , raf = root['request' + suffix]
	  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]
	
	for(var i = 0; !raf && i < vendors.length; i++) {
	  raf = root[vendors[i] + 'Request' + suffix]
	  caf = root[vendors[i] + 'Cancel' + suffix]
	      || root[vendors[i] + 'CancelRequest' + suffix]
	}
	
	// Some versions of FF have rAF but not cAF
	if(!raf || !caf) {
	  var last = 0
	    , id = 0
	    , queue = []
	    , frameDuration = 1000 / 60
	
	  raf = function(callback) {
	    if(queue.length === 0) {
	      var _now = now()
	        , next = Math.max(0, frameDuration - (_now - last))
	      last = next + _now
	      setTimeout(function() {
	        var cp = queue.slice(0)
	        // Clear queue here to prevent
	        // callbacks from appending listeners
	        // to the current frame's queue
	        queue.length = 0
	        for(var i = 0; i < cp.length; i++) {
	          if(!cp[i].cancelled) {
	            try{
	              cp[i].callback(last)
	            } catch(e) {
	              setTimeout(function() { throw e }, 0)
	            }
	          }
	        }
	      }, Math.round(next))
	    }
	    queue.push({
	      handle: ++id,
	      callback: callback,
	      cancelled: false
	    })
	    return id
	  }
	
	  caf = function(handle) {
	    for(var i = 0; i < queue.length; i++) {
	      if(queue[i].handle === handle) {
	        queue[i].cancelled = true
	      }
	    }
	  }
	}
	
	module.exports = function(fn) {
	  // Wrap in a new function to prevent
	  // `cancel` potentially being assigned
	  // to the native rAF function
	  return raf.call(root, fn)
	}
	module.exports.cancel = function() {
	  caf.apply(root, arguments)
	}
	module.exports.polyfill = function(object) {
	  if (!object) {
	    object = root;
	  }
	  object.requestAnimationFrame = raf
	  object.cancelAnimationFrame = caf
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 239:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _jump = __webpack_require__(608);
	
	var _jump2 = _interopRequireDefault(_jump);
	
	var _func = __webpack_require__(784);
	
	var _scroll = __webpack_require__(785);
	
	var _hash = __webpack_require__(240);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var defaultConfig = {
	  offset: 0,
	  scrollDuration: 400,
	  keepLastAnchorHash: false
	};
	
	var Manager = function Manager() {
	  var _this = this;
	
	  _classCallCheck(this, Manager);
	
	  this.addListeners = function () {
	    window.addEventListener('scroll', _this.scrollHandler, false);
	    window.addEventListener('hashchange', _this.handleHashChange);
	  };
	
	  this.removeListeners = function () {
	    window.removeEventListener('scroll', _this.scrollHandler, false);
	    window.removeEventListener('hashchange', _this.handleHashChange);
	  };
	
	  this.configure = function (config) {
	    _this.config = _extends({}, defaultConfig, config);
	  };
	
	  this.goToTop = function () {
	    if ((0, _scroll.getScrollTop)() === 0) return;
	    _this.forcedHash = true;
	    window.scroll(0, 0);
	  };
	
	  this.addAnchor = function (id, component) {
	    // if this is the first anchor, set up listeners
	    if (Object.keys(_this.anchors).length === 0) {
	      _this.addListeners();
	    }
	    _this.forceHashUpdate();
	    _this.anchors[id] = component;
	  };
	
	  this.removeAnchor = function (id) {
	    delete _this.anchors[id];
	    // if this is the last anchor, remove listeners
	    if (Object.keys(_this.anchors).length === 0) {
	      _this.removeListeners();
	    }
	  };
	
	  this.handleScroll = function () {
	    var _config = _this.config,
	        offset = _config.offset,
	        keepLastAnchorHash = _config.keepLastAnchorHash;
	
	    var bestAnchorId = (0, _scroll.getBestAnchorGivenScrollLocation)(_this.anchors, offset);
	
	    if (bestAnchorId && (0, _hash.getHash)() !== bestAnchorId) {
	      _this.forcedHash = true;
	      (0, _hash.updateHash)(bestAnchorId, false);
	    } else if (!bestAnchorId && !keepLastAnchorHash) {
	      (0, _hash.removeHash)();
	    }
	  };
	
	  this.handleHashChange = function (e) {
	    if (_this.forcedHash) {
	      _this.forcedHash = false;
	    } else {
	      _this.goToSection((0, _hash.getHash)());
	    }
	  };
	
	  this.goToSection = function (id) {
	    var element = _this.anchors[id];
	    if (element) {
	      (0, _jump2.default)(element, {
	        duration: _this.config.scrollDuration,
	        offset: _this.config.offset
	      });
	    } else {
	      // make sure that standard hash anchors don't break.
	      // simply jump to them.
	      element = document.getElementById(id);
	      if (element) {
	        (0, _jump2.default)(element, {
	          duration: 0,
	          offset: _this.config.offset
	        });
	      }
	    }
	  };
	
	  this.anchors = {};
	  this.forcedHash = false;
	  this.config = defaultConfig;
	
	  this.scrollHandler = (0, _func.debounce)(this.handleScroll, 100);
	  this.forceHashUpdate = (0, _func.debounce)(this.handleHashChange, 1);
	};
	
	exports.default = new Manager();

/***/ }),

/***/ 782:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(135);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Manager = __webpack_require__(239);
	
	var _Manager2 = _interopRequireDefault(_Manager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ScrollableAnchor = function (_Component) {
	  _inherits(ScrollableAnchor, _Component);
	
	  function ScrollableAnchor(props) {
	    _classCallCheck(this, ScrollableAnchor);
	
	    var _this = _possibleConstructorReturn(this, (ScrollableAnchor.__proto__ || Object.getPrototypeOf(ScrollableAnchor)).call(this, props));
	
	    _this.id = props.id || props.children.ref;
	    return _this;
	  }
	
	  _createClass(ScrollableAnchor, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var element = _reactDom2.default.findDOMNode(this.refs[Object.keys(this.refs)[0]]);
	      _Manager2.default.addAnchor(this.id, element);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      _Manager2.default.removeAnchor(this.id);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          id = _props.id;
	
	
	      return _react2.default.cloneElement(children, {
	        ref: children.ref || id
	      });
	    }
	  }]);
	
	  return ScrollableAnchor;
	}(_react.Component);
	
	ScrollableAnchor.propTypes = {
	  children: _propTypes2.default.node,
	  id: _propTypes2.default.string
	};
	exports.default = ScrollableAnchor;

/***/ }),

/***/ 783:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.removeHash = exports.goToAnchor = exports.configureAnchors = exports.goToTop = undefined;
	
	var _hash = __webpack_require__(240);
	
	Object.defineProperty(exports, 'goToAnchor', {
	  enumerable: true,
	  get: function get() {
	    return _hash.updateHash;
	  }
	});
	Object.defineProperty(exports, 'removeHash', {
	  enumerable: true,
	  get: function get() {
	    return _hash.removeHash;
	  }
	});
	
	var _ScrollableAnchor = __webpack_require__(782);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ScrollableAnchor).default;
	  }
	});
	
	var _Manager = __webpack_require__(239);
	
	var _Manager2 = _interopRequireDefault(_Manager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var goToTop = exports.goToTop = _Manager2.default.goToTop;
	var configureAnchors = exports.configureAnchors = _Manager2.default.configure;

/***/ }),

/***/ 784:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var _arguments = arguments;
	var debounce = exports.debounce = function debounce(func, wait, immediate) {
	  var timeout = void 0;
	  return function () {
	    var context = undefined;
	    var args = _arguments;
	    var later = function later() {
	      timeout = null;
	      if (!immediate) {
	        func.apply(context, args);
	      }
	    };
	    var callNow = immediate && !timeout;
	    clearTimeout(timeout);
	    timeout = setTimeout(later, wait);
	    if (callNow) {
	      func.apply(context, args);
	    }
	  };
	};

/***/ }),

/***/ 240:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var getHash = exports.getHash = function getHash() {
	  return decodeURI(window.location.hash.slice(1));
	};
	
	var updateHash = exports.updateHash = function updateHash(hash, affectHistory) {
	  if (affectHistory) {
	    window.location.hash = hash;
	  } else {
	    window.location.replace("#" + hash);
	  }
	};
	
	// remove hash in url without affecting history or forcing reload
	var removeHash = exports.removeHash = function removeHash() {
	  history.replaceState("", document.title, window.location.pathname + window.location.search);
	};

/***/ }),

/***/ 785:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var getScrollTop = exports.getScrollTop = function getScrollTop() {
	  return document.body.scrollTop || document.documentElement.scrollTop;
	};
	
	// get vertical offsets of element, taking scrollTop into consideration
	var getElementOffset = exports.getElementOffset = function getElementOffset(element) {
	  var scrollTop = getScrollTop();
	
	  var _element$getBoundingC = element.getBoundingClientRect(),
	      top = _element$getBoundingC.top,
	      bottom = _element$getBoundingC.bottom;
	
	  return {
	    top: Math.floor(top + scrollTop),
	    bottom: Math.floor(bottom + scrollTop)
	  };
	};
	
	// does scrollTop live within element bounds?
	var doesElementContainScrollTop = exports.doesElementContainScrollTop = function doesElementContainScrollTop(element) {
	  var extraOffset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	  var scrollTop = getScrollTop();
	  var offsetTop = getElementOffset(element).top + extraOffset;
	  return scrollTop >= offsetTop && scrollTop < offsetTop + element.offsetHeight;
	};
	
	// is el2's location more relevant than el2,
	// parent-child relationship aside?
	var checkLocationRelevance = exports.checkLocationRelevance = function checkLocationRelevance(el1, el2) {
	  var _getElementOffset = getElementOffset(el1),
	      top1 = _getElementOffset.top,
	      bottom1 = _getElementOffset.bottom;
	
	  var _getElementOffset2 = getElementOffset(el2),
	      top2 = _getElementOffset2.top,
	      bottom2 = _getElementOffset2.bottom;
	
	  if (top1 === top2) {
	    if (bottom1 === bottom2) {
	      // top and bottom of compared elements are the same,
	      // so return one randomly in a deterministic way
	      return el1 < el2;
	    }
	    // top of compared elements is the same, so return whichever
	    // element has its bottom higher on the page
	    return bottom2 < bottom1;
	  }
	  // top of compared elements differ, so return true
	  // if tested element has its top lower on the page
	  return top2 > top1;
	};
	
	// check if el2 is more relevant than el1, considering child-parent
	// relationships as well as node location.
	var checkElementRelevance = exports.checkElementRelevance = function checkElementRelevance(el1, el2) {
	  if (el1.contains(el2)) {
	    // el2 is child, so it gains relevance priority
	    return true;
	  } else if (!el2.contains(el1) && checkLocationRelevance(el1, el2)) {
	    // el1 and el2 are unrelated, but el2 has a better location,
	    // so it gains relevance priority
	    return true;
	  }
	  return false;
	};
	
	// given a set of anchors, find which one is, given the following logic:
	// 1. children nodes are more relevant than parent nodes
	// 2. if neither node contains the other, and their top locations differ,
	//    the node with the top lower on the page is more relevant
	// 3. if neither node contains the other, and their top locations are the same,
	//    the node with the bottom higher on the page is more relevant
	// 4. if neither node contains the other, and their top and bottom locations
	//    are the same, a node is chosen at random, in a deterministic way,
	//    to be more relevant.
	var getBestAnchorGivenScrollLocation = exports.getBestAnchorGivenScrollLocation = function getBestAnchorGivenScrollLocation(anchors, offset) {
	  var bestId = void 0,
	      bestElement = void 0;
	
	  Object.keys(anchors).forEach(function (id) {
	    var element = anchors[id];
	    if (doesElementContainScrollTop(element, offset)) {
	      if (!bestElement || checkElementRelevance(bestElement, element)) {
	        bestElement = element;
	        bestId = id;
	      }
	    }
	  });
	  return bestId;
	};

/***/ }),

/***/ 786:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	/* global window, document */
	
	'use strict';
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _subscribeUiEvent = __webpack_require__(816);
	
	var _classnames = __webpack_require__(275);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _shallowequal = __webpack_require__(65);
	
	var _shallowequal2 = _interopRequireDefault(_shallowequal);
	
	// constants
	var STATUS_ORIGINAL = 0; // The default status, locating at the original position.
	var STATUS_RELEASED = 1; // The released status, locating at somewhere on document but not default one.
	var STATUS_FIXED = 2; // The sticky status, locating fixed to the top or the bottom of screen.
	
	var TRANSFORM_PROP = 'transform';
	
	// global variable for all instances
	var doc;
	var docBody;
	var docEl;
	var canEnableTransforms = true; // Use transform by default, so no Sticky on lower-end browser when no Modernizr
	var M;
	var scrollDelta = 0;
	var win;
	var winHeight = -1;
	
	var Sticky = (function (_Component) {
	    _inherits(Sticky, _Component);
	
	    function Sticky(props, context) {
	        _classCallCheck(this, Sticky);
	
	        _get(Object.getPrototypeOf(Sticky.prototype), 'constructor', this).call(this, props, context);
	        this.handleResize = this.handleResize.bind(this);
	        this.handleScroll = this.handleScroll.bind(this);
	        this.handleScrollStart = this.handleScrollStart.bind(this);
	        this.delta = 0;
	        this.stickyTop = 0;
	        this.stickyBottom = 0;
	        this.frozen = false;
	        this.skipNextScrollEvent = false;
	        this.scrollTop = -1;
	
	        this.bottomBoundaryTarget;
	        this.topTarget;
	        this.subscribers;
	
	        this.state = {
	            top: 0, // A top offset from viewport top where Sticky sticks to when scrolling up
	            bottom: 0, // A bottom offset from viewport top where Sticky sticks to when scrolling down
	            width: 0, // Sticky width
	            height: 0, // Sticky height
	            x: 0, // The original x of Sticky
	            y: 0, // The original y of Sticky
	            topBoundary: 0, // The top boundary on document
	            bottomBoundary: Infinity, // The bottom boundary on document
	            status: STATUS_ORIGINAL, // The Sticky status
	            pos: 0, // Real y-axis offset for rendering position-fixed and position-relative
	            activated: false // once browser info is available after mounted, it becomes true to avoid checksum error
	        };
	    }
	
	    _createClass(Sticky, [{
	        key: 'getTargetHeight',
	        value: function getTargetHeight(target) {
	            return target && target.offsetHeight || 0;
	        }
	    }, {
	        key: 'getTopPosition',
	        value: function getTopPosition(top) {
	            // TODO, topTarget is for current layout, may remove
	            // a top argument can be provided to override reading from the props
	            top = top || this.props.top || this.props.topTarget || 0;
	            if (typeof top === 'string') {
	                if (!this.topTarget) {
	                    this.topTarget = doc.querySelector(top);
	                }
	                top = this.getTargetHeight(this.topTarget);
	            }
	            return top;
	        }
	    }, {
	        key: 'getTargetBottom',
	        value: function getTargetBottom(target) {
	            if (!target) {
	                return -1;
	            }
	            var rect = target.getBoundingClientRect();
	            return this.scrollTop + rect.bottom;
	        }
	    }, {
	        key: 'getBottomBoundary',
	        value: function getBottomBoundary(bottomBoundary) {
	            // a bottomBoundary can be provided to avoid reading from the props
	            var boundary = bottomBoundary || this.props.bottomBoundary;
	
	            // TODO, bottomBoundary was an object, depricate it later.
	            if (typeof boundary === 'object') {
	                boundary = boundary.value || boundary.target || 0;
	            }
	
	            if (typeof boundary === 'string') {
	                if (!this.bottomBoundaryTarget) {
	                    this.bottomBoundaryTarget = doc.querySelector(boundary);
	                }
	                boundary = this.getTargetBottom(this.bottomBoundaryTarget);
	            }
	            return boundary && boundary > 0 ? boundary : Infinity;
	        }
	    }, {
	        key: 'reset',
	        value: function reset() {
	            this.setState({
	                status: STATUS_ORIGINAL,
	                pos: 0
	            });
	        }
	    }, {
	        key: 'release',
	        value: function release(pos) {
	            this.setState({
	                status: STATUS_RELEASED,
	                pos: pos - this.state.y
	            });
	        }
	    }, {
	        key: 'fix',
	        value: function fix(pos) {
	            this.setState({
	                status: STATUS_FIXED,
	                pos: pos
	            });
	        }
	
	        /**
	         * Update the initial position, width, and height. It should update whenever children change.
	         * @param {Object} options optional top and bottomBoundary new values
	         */
	    }, {
	        key: 'updateInitialDimension',
	        value: function updateInitialDimension(options) {
	            options = options || {};
	
	            var outerRect = this.outerElement.getBoundingClientRect();
	            var innerRect = this.innerElement.getBoundingClientRect();
	
	            var width = outerRect.width || outerRect.right - outerRect.left;
	            var height = innerRect.height || innerRect.bottom - innerRect.top;;
	            var outerY = outerRect.top + this.scrollTop;
	
	            this.setState({
	                top: this.getTopPosition(options.top),
	                bottom: Math.min(this.state.top + height, winHeight),
	                width: width,
	                height: height,
	                x: outerRect.left,
	                y: outerY,
	                bottomBoundary: this.getBottomBoundary(options.bottomBoundary),
	                topBoundary: outerY
	            });
	        }
	    }, {
	        key: 'handleResize',
	        value: function handleResize(e, ae) {
	            if (this.props.shouldFreeze()) {
	                return;
	            }
	
	            winHeight = ae.resize.height;
	            this.updateInitialDimension();
	            this.update();
	        }
	    }, {
	        key: 'handleScrollStart',
	        value: function handleScrollStart(e, ae) {
	            this.frozen = this.props.shouldFreeze();
	
	            if (this.frozen) {
	                return;
	            }
	
	            if (this.scrollTop === ae.scroll.top) {
	                // Scroll position hasn't changed,
	                // do nothing
	                this.skipNextScrollEvent = true;
	            } else {
	                this.scrollTop = ae.scroll.top;
	                this.updateInitialDimension();
	            }
	        }
	    }, {
	        key: 'handleScroll',
	        value: function handleScroll(e, ae) {
	            // Scroll doesn't need to be handled
	            if (this.skipNextScrollEvent) {
	                this.skipNextScrollEvent = false;
	                return;
	            }
	
	            scrollDelta = ae.scroll.delta;
	            this.scrollTop = ae.scroll.top;
	            this.update();
	        }
	
	        /**
	         * Update Sticky position.
	         */
	    }, {
	        key: 'update',
	        value: function update() {
	            var disabled = !this.props.enabled || this.state.bottomBoundary - this.state.topBoundary <= this.state.height || this.state.width === 0 && this.state.height === 0;
	
	            if (disabled) {
	                if (this.state.status !== STATUS_ORIGINAL) {
	                    this.reset();
	                }
	                return;
	            }
	
	            var delta = scrollDelta;
	            // "top" and "bottom" are the positions that this.state.top and this.state.bottom project
	            // on document from viewport.
	            var top = this.scrollTop + this.state.top;
	            var bottom = this.scrollTop + this.state.bottom;
	
	            // There are 2 principles to make sure Sticky won't get wrong so much:
	            // 1. Reset Sticky to the original postion when "top" <= topBoundary
	            // 2. Release Sticky to the bottom boundary when "bottom" >= bottomBoundary
	            if (top <= this.state.topBoundary) {
	                // #1
	                this.reset();
	            } else if (bottom >= this.state.bottomBoundary) {
	                // #2
	                this.stickyBottom = this.state.bottomBoundary;
	                this.stickyTop = this.stickyBottom - this.state.height;
	                this.release(this.stickyTop);
	            } else {
	                if (this.state.height > winHeight - this.state.top) {
	                    // In this case, Sticky is higher then viewport minus top offset
	                    switch (this.state.status) {
	                        case STATUS_ORIGINAL:
	                            this.release(this.state.y);
	                            this.stickyTop = this.state.y;
	                            this.stickyBottom = this.stickyTop + this.state.height;
	                        // Commentting out "break" is on purpose, because there is a chance to transit to FIXED
	                        // from ORIGINAL when calling window.scrollTo().
	                        // break;
	                        case STATUS_RELEASED:
	                            // If "top" and "bottom" are inbetween stickyTop and stickyBottom, then Sticky is in
	                            // RELEASE status. Otherwise, it changes to FIXED status, and its bottom sticks to
	                            // viewport bottom when scrolling down, or its top sticks to viewport top when scrolling up.
	                            this.stickyBottom = this.stickyTop + this.state.height;
	                            if (delta > 0 && bottom > this.stickyBottom) {
	                                this.fix(this.state.bottom - this.state.height);
	                            } else if (delta < 0 && top < this.stickyTop) {
	                                this.fix(this.state.top);
	                            }
	                            break;
	                        case STATUS_FIXED:
	                            var toRelease = true;
	                            var pos = this.state.pos;
	                            var height = this.state.height;
	                            // In regular cases, when Sticky is in FIXED status,
	                            // 1. it's top will stick to the screen top,
	                            // 2. it's bottom will stick to the screen bottom,
	                            // 3. if not the cases above, then it's height gets changed
	                            if (delta > 0 && pos === this.state.top) {
	                                // case 1, and scrolling down
	                                this.stickyTop = top - delta;
	                                this.stickyBottom = this.stickyTop + height;
	                            } else if (delta < 0 && pos === this.state.bottom - height) {
	                                // case 2, and scrolling up
	                                this.stickyBottom = bottom - delta;
	                                this.stickyTop = this.stickyBottom - height;
	                            } else if (pos !== this.state.bottom - height && pos !== this.state.top) {
	                                // case 3
	                                // This case only happens when Sticky's bottom sticks to the screen bottom and
	                                // its height gets changed. Sticky should be in RELEASE status and update its
	                                // sticky bottom by calculating how much height it changed.
	                                var deltaHeight = pos + height - this.state.bottom;
	                                this.stickyBottom = bottom - delta + deltaHeight;
	                                this.stickyTop = this.stickyBottom - height;
	                            } else {
	                                toRelease = false;
	                            }
	
	                            if (toRelease) {
	                                this.release(this.stickyTop);
	                            }
	                            break;
	                    }
	                } else {
	                    // In this case, Sticky is shorter then viewport minus top offset
	                    // and will always fix to the top offset of viewport
	                    this.fix(this.state.top);
	                }
	            }
	            this.delta = delta;
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            this.updateInitialDimension(nextProps);
	            this.update();
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps, prevState) {
	            var _this = this;
	
	            if (prevState.status !== this.state.status && this.props.onStateChange) {
	                this.props.onStateChange({ status: this.state.status });
	            }
	            // if the props for enabling are toggled, then trigger the update or reset depending on the current props
	            if (prevProps.enabled !== this.props.enabled) {
	                if (this.props.enabled) {
	                    this.setState({ activated: true }, function () {
	                        _this.updateInitialDimension();
	                        _this.update();
	                    });
	                } else {
	                    this.setState({ activated: false }, function () {
	                        _this.reset();
	                    });
	                }
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            var subscribers = this.subscribers || [];
	            for (var i = subscribers.length - 1; i >= 0; i--) {
	                this.subscribers[i].unsubscribe();
	            }
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            // Only initialize the globals if this is the first
	            // time this component type has been mounted
	            if (!win) {
	                win = window;
	                doc = document;
	                docEl = doc.documentElement;
	                docBody = doc.body;
	                winHeight = win.innerHeight || docEl.clientHeight;
	                M = window.Modernizr;
	                // No Sticky on lower-end browser when no Modernizr
	                if (M && M.prefixed) {
	                    canEnableTransforms = M.csstransforms3d;
	                    TRANSFORM_PROP = M.prefixed('transform');
	                }
	            }
	
	            // when mount, the scrollTop is not necessary on the top
	            this.scrollTop = docBody.scrollTop + docEl.scrollTop;
	
	            if (this.props.enabled) {
	                this.setState({ activated: true });
	                this.updateInitialDimension();
	                this.update();
	            }
	            // bind the listeners regardless if initially enabled - allows the component to toggle sticky functionality
	            this.subscribers = [(0, _subscribeUiEvent.subscribe)('scrollStart', this.handleScrollStart.bind(this), { useRAF: true }), (0, _subscribeUiEvent.subscribe)('scroll', this.handleScroll.bind(this), { useRAF: true, enableScrollInfo: true }), (0, _subscribeUiEvent.subscribe)('resize', this.handleResize.bind(this), { enableResizeInfo: true })];
	        }
	    }, {
	        key: 'translate',
	        value: function translate(style, pos) {
	            var enableTransforms = canEnableTransforms && this.props.enableTransforms;
	            if (enableTransforms && this.state.activated) {
	                style[TRANSFORM_PROP] = 'translate3d(0,' + Math.round(pos) + 'px,0)';
	            } else {
	                style.top = pos + 'px';
	            }
	        }
	    }, {
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps, nextState) {
	            return !this.props.shouldFreeze() && !((0, _shallowequal2['default'])(this.props, nextProps) && (0, _shallowequal2['default'])(this.state, nextState));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _classNames,
	                _this2 = this;
	
	            // TODO, "overflow: auto" prevents collapse, need a good way to get children height
	            var innerStyle = {
	                position: this.state.status === STATUS_FIXED ? 'fixed' : 'relative',
	                top: this.state.status === STATUS_FIXED ? '0px' : '',
	                zIndex: this.props.innerZ
	            };
	            var outerStyle = {};
	
	            // always use translate3d to enhance the performance
	            this.translate(innerStyle, this.state.pos);
	            if (this.state.status !== STATUS_ORIGINAL) {
	                innerStyle.width = this.state.width + 'px';
	                outerStyle.height = this.state.height + 'px';
	            }
	
	            var outerClasses = (0, _classnames2['default'])('sticky-outer-wrapper', this.props.className, (_classNames = {}, _defineProperty(_classNames, this.props.activeClass, this.state.status === STATUS_FIXED), _defineProperty(_classNames, this.props.releasedClass, this.state.status === STATUS_RELEASED), _classNames));
	
	            var children = this.props.children;
	
	            return _react2['default'].createElement(
	                'div',
	                { ref: function (outer) {
	                        _this2.outerElement = outer;
	                    }, className: outerClasses, style: outerStyle },
	                _react2['default'].createElement(
	                    'div',
	                    { ref: function (inner) {
	                            _this2.innerElement = inner;
	                        }, className: 'sticky-inner-wrapper', style: innerStyle },
	                    typeof children === 'function' ? children({ status: this.state.status }) : children
	                )
	            );
	        }
	    }]);
	
	    return Sticky;
	})(_react.Component);
	
	Sticky.displayName = 'Sticky';
	
	Sticky.defaultProps = {
	    shouldFreeze: function shouldFreeze() {
	        return false;
	    },
	    enabled: true,
	    top: 0,
	    bottomBoundary: 0,
	    enableTransforms: true,
	    activeClass: 'active',
	    releasedClass: 'released',
	    onStateChange: null
	};
	
	/**
	 * @param {Bool} enabled A switch to enable or disable Sticky.
	 * @param {String/Number} top A top offset px for Sticky. Could be a selector representing a node
	 *        whose height should serve as the top offset.
	 * @param {String/Number} bottomBoundary A bottom boundary px on document where Sticky will stop.
	 *        Could be a selector representing a node whose bottom should serve as the bottom boudary.
	 */
	Sticky.propTypes = {
	    enabled: _propTypes2['default'].bool,
	    top: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number]),
	    bottomBoundary: _propTypes2['default'].oneOfType([_propTypes2['default'].object, // TODO, may remove
	    _propTypes2['default'].string, _propTypes2['default'].number]),
	    enableTransforms: _propTypes2['default'].bool,
	    activeClass: _propTypes2['default'].string,
	    releasedClass: _propTypes2['default'].string,
	    onStateChange: _propTypes2['default'].func,
	    shouldFreeze: _propTypes2['default'].func,
	    innerZ: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number])
	};
	
	Sticky.STATUS_ORIGINAL = STATUS_ORIGINAL;
	Sticky.STATUS_RELEASED = STATUS_RELEASED;
	Sticky.STATUS_FIXED = STATUS_FIXED;
	
	module.exports = Sticky;


/***/ }),

/***/ 787:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(786);


/***/ }),

/***/ 65:
/***/ (function(module, exports) {

	//
	
	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	  if (ret !== void 0) {
	    return !!ret;
	  }
	
	  if (objA === objB) {
	    return true;
	  }
	
	  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	  // Test for A's keys different from B.
	  for (var idx = 0; idx < keysA.length; idx++) {
	    var key = keysA[idx];
	
	    if (!bHasOwnProperty(key)) {
	      return false;
	    }
	
	    var valueA = objA[key];
	    var valueB = objB[key];
	
	    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	
	    if (ret === false || (ret === void 0 && valueA !== valueB)) {
	      return false;
	    }
	  }
	
	  return true;
	};


/***/ }),

/***/ 810:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Copyright 2015, Yahoo! Inc.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */
	/* global window, document */
	
	var _globalVars = __webpack_require__(66);
	
	var _globalVars2 = _interopRequireDefault(_globalVars);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var resize = { // eslint-disable-line prefer-const
	  width: 0,
	  height: 0
	};
	var scroll = { // eslint-disable-line prefer-const
	  delta: 0,
	  top: 0
	};
	var touch = { // eslint-disable-line prefer-const
	  axisIntention: '',
	  startX: 0,
	  startY: 0,
	  deltaX: 0,
	  deltaY: 0
	};
	
	var INTENTION_THRESHOLD = 5;
	
	var getXY = function getXY(pos) {
	  var t = { x: 0, y: 0 }; // eslint-disable-line prefer-const
	  var docBody = document.body;
	  var docEl = document.documentElement;
	
	  if (pos.pageX || pos.pageY) {
	    t.x = pos.pageX;
	    t.y = pos.pageY;
	  } else {
	    t.x = pos.clientX + docBody.scrollLeft + docEl.scrollLeft;
	    t.y = pos.clientY + docBody.scrollTop + docEl.scrollTop;
	  }
	
	  return t;
	};
	
	/**
	 * ArgmentedEvent will hold some global information, such like window scroll postion,
	 * so that those information is only calculated once.
	 * @param {Object} option - The option for SyntheticEvent
	 */
	
	var AugmentedEvent = function () {
	  function AugmentedEvent() {
	    var option = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    _classCallCheck(this, AugmentedEvent);
	
	    var mainType = (option.mainType || '').toLowerCase();
	    var subType = (option.subType || '').toLowerCase();
	
	    this.mainType = mainType;
	    this.subType = subType;
	    this.type = mainType + subType.charAt(0).toUpperCase() + subType.slice(1) || '';
	    this.scroll = scroll;
	    this.resize = resize;
	    this.touch = touch;
	  }
	
	  _createClass(AugmentedEvent, [{
	    key: 'update',
	    value: function update(e) {
	      var mainType = this.mainType,
	          subType = this.subType;
	
	      var docEl = document.documentElement;
	
	      if (_globalVars2.default.enableScrollInfo && (mainType === 'scroll' || mainType === 'touchmove')) {
	        var top = docEl.scrollTop + document.body.scrollTop;
	        // Prevent delta from being 0
	        if (top !== this.scroll.top) {
	          this.scroll.delta = top - this.scroll.top;
	          this.scroll.top = top;
	        }
	      }
	      if (_globalVars2.default.enableResizeInfo && mainType === 'resize') {
	        this.resize.width = window.innerWidth || docEl.clientWidth;
	        this.resize.height = window.innerHeight || docEl.clientHeight;
	      }
	      if (_globalVars2.default.enableTouchInfo && e.touches && (mainType === 'touchstart' || mainType === 'touchmove' || mainType === 'touchend')) {
	        var pos = void 0;
	        var absX = void 0;
	        var absY = void 0;
	        if (mainType === 'touchstart' || subType === 'start') {
	          pos = getXY(e.touches[0]);
	          this.touch.axisIntention = '';
	          this.touch.startX = pos.x;
	          this.touch.startY = pos.y;
	          this.touch.deltaX = 0;
	          this.touch.deltaY = 0;
	        } else if (mainType === 'touchmove') {
	          pos = getXY(e.touches[0]);
	          this.touch.deltaX = pos.x - this.touch.startX;
	          this.touch.deltaY = pos.y - this.touch.startY;
	          if (this.touch.axisIntention === '') {
	            absX = Math.abs(this.touch.deltaX);
	            absY = Math.abs(this.touch.deltaY);
	            if (absX > INTENTION_THRESHOLD && absX >= absY) {
	              this.touch.axisIntention = 'x';
	            } else if (absY > INTENTION_THRESHOLD && absY > absX) {
	              this.touch.axisIntention = 'y';
	            }
	          }
	        }
	      }
	    }
	  }]);
	
	  return AugmentedEvent;
	}();
	
	exports.default = AugmentedEvent;
	module.exports = exports['default'];


/***/ }),

/***/ 247:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	
	var EVENT_END_DELAY = exports.EVENT_END_DELAY = 100;
	var DEFAULT_THROTTLE_RATE = exports.DEFAULT_THROTTLE_RATE = 50;


/***/ }),

/***/ 66:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _eventemitter = __webpack_require__(353);
	
	var _eventemitter2 = _interopRequireDefault(_eventemitter);
	
	var _supportPassiveEvent = __webpack_require__(812);
	
	var _supportPassiveEvent2 = _interopRequireDefault(_supportPassiveEvent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	
	exports.default = {
	  connections: {},
	  EE: new _eventemitter2.default(),
	  enableResizeInfo: false,
	  enableScrollInfo: false,
	  listeners: {},
	  removers: [],
	  supportPassiveEvent: _supportPassiveEvent2.default
	};
	module.exports = exports['default'];


/***/ }),

/***/ 248:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	/* global navigator, parseFloat */
	
	// less then or equal to IE8
	var leIE8 = false; // eslint-disable-line import/no-mutable-exports
	
	if (typeof navigator !== 'undefined') {
	  var matches = navigator.userAgent.match(/MSIE (\d+\.\d+)/);
	  if (matches) {
	    leIE8 = parseFloat(matches[1], 10) < 9;
	  }
	}
	
	exports.default = leIE8;
	module.exports = exports['default'];


/***/ }),

/***/ 249:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(680);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _globalVars = __webpack_require__(66);
	
	var _globalVars2 = _interopRequireDefault(_globalVars);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	
	var supportPassiveEvent = _globalVars2.default.supportPassiveEvent;
	
	
	var defaultEventOption = {
	  capture: false,
	  passive: false
	};
	
	/**
	 * Cross-browser addEventListener.
	 * @method listen
	 * @param {Object} target - The target to add event listener.
	 * @param {String} eventType - The event type.
	 * @param {Function} handler - The event handler.
	 * @param {Object} handler - The options object that specifies
	 * characteristics about the event listener.
	 * @return {Object} The object to be able to remove the handler.
	 */
	function listen(target, eventType, handler, options) {
	  var add = 'addEventListener';
	  var _remove = 'removeEventListener';
	  var type = eventType;
	
	  var eventOptions = supportPassiveEvent ? (0, _assign2.default)({}, defaultEventOption, options) : false;
	
	  if (!target.addEventListener && target.attachEvent) {
	    add = 'attachEvent';
	    _remove = 'detachEvent';
	    type = 'on' + eventType;
	  }
	  target[add](type, handler, eventOptions);
	
	  return {
	    remove: function remove() {
	      target[_remove](eventType, handler);
	    }
	  };
	}
	
	exports.default = listen;
	module.exports = exports['default'];


/***/ }),

/***/ 811:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _raf = __webpack_require__(700);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getTime = Date.now ||
	/* istanbul ignore next */function () {
	  return new Date().getTime();
	}; /**
	    * Copyright 2015, Yahoo! Inc.
	    * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	    */
	
	function rAFThrottle(func) {
	  var throttle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 15;
	
	  var context = void 0;
	  var args = void 0;
	  var last = 0;
	  var requestId = 0;
	
	  var later = function later() {
	    var now = getTime();
	    var remaining = throttle - (now - last);
	
	    if (remaining <= 0) {
	      last = now;
	      requestId = 0;
	      func.apply(context, args);
	    } else {
	      requestId = (0, _raf2.default)(later);
	    }
	  };
	
	  return function throttledFunc() {
	    context = this;
	    args = arguments; // eslint-disable-line prefer-rest-params
	
	    if (!requestId) {
	      requestId = (0, _raf2.default)(later);
	    }
	  };
	}
	
	exports.default = rAFThrottle;
	module.exports = exports['default'];


/***/ }),

/***/ 812:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/* global window */
	
	var passiveSupported = false; // eslint-disable-line import/no-mutable-exports
	
	if (typeof window !== 'undefined') {
	  try {
	    var options = Object.defineProperty({}, 'passive', {
	      get: function get() {
	        passiveSupported = true;
	      }
	    });
	
	    window.addEventListener('test', null, options);
	  } catch (err) {} // eslint-disable-line no-empty
	}
	
	exports.default = passiveSupported;
	module.exports = exports['default'];


/***/ }),

/***/ 813:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _clone = __webpack_require__(681);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	var _throttle = __webpack_require__(693);
	
	var _throttle2 = _interopRequireDefault(_throttle);
	
	var _noop = __webpack_require__(690);
	
	var _noop2 = _interopRequireDefault(_noop);
	
	var _AugmentedEvent = __webpack_require__(810);
	
	var _AugmentedEvent2 = _interopRequireDefault(_AugmentedEvent);
	
	var _globalVars = __webpack_require__(66);
	
	var _globalVars2 = _interopRequireDefault(_globalVars);
	
	var _leIE = __webpack_require__(248);
	
	var _leIE2 = _interopRequireDefault(_leIE);
	
	var _listen = __webpack_require__(249);
	
	var _listen2 = _interopRequireDefault(_listen);
	
	var _rAFThrottle = __webpack_require__(811);
	
	var _rAFThrottle2 = _interopRequireDefault(_rAFThrottle);
	
	var _constants = __webpack_require__(247);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var connections = _globalVars2.default.connections,
	    EE = _globalVars2.default.EE,
	    listeners = _globalVars2.default.listeners,
	    removers = _globalVars2.default.removers;
	
	// global variables
	
	
	// constants
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	/* global window, document, setTimeout */
	
	var doc = void 0;
	var win = void 0;
	var body = void 0;
	var hashId = 0;
	
	if (typeof window !== 'undefined') {
	  win = window;
	  doc = win.document || document;
	  body = doc.body;
	}
	
	function getHash(domNode) {
	  return domNode.id || 'target-id-' + hashId++; // eslint-disable-line
	}
	
	/**
	 * Connect a throttled event to a throttled main event, and return an event remover.
	 * The number of connections to a throttled main event will be kept. If all throttled events
	 * are removed, then remove throttled main event.
	 * @method connectThrottle
	 * @param {String} throttledEvent - A throttled event
	 * @param {Function} cb - Callback function
	 * @param {Object} ctx - The "this"
	 * @param {String} throttledMainEvent - A throttled main event
	 * @return {Object} An event remover
	 */
	function connectThrottle(throttledEvent, cb, ctx, throttledMainEvent) {
	  EE.on(throttledEvent, cb || _noop2.default, ctx);
	  throttledMainEvent = throttledMainEvent || throttledEvent;
	  connections[throttledMainEvent] = (connections[throttledMainEvent] || 0) + 1;
	  return {
	    _type: throttledEvent,
	    _cb: cb,
	    _ctx: ctx,
	    unsubscribe: function unsubscribe() {
	      if (!this._type) {
	        return;
	      }
	
	      EE.removeListener(throttledEvent, cb, ctx);
	      connections[throttledMainEvent]--;
	      if (connections[throttledMainEvent] === 0) {
	        listeners[throttledMainEvent].remove();
	        listeners[throttledMainEvent] = undefined;
	      }
	
	      this._type = undefined;
	      this._cb = undefined;
	      this._ctx = undefined;
	
	      // remove the remover from removers array
	      for (var i = removers.length - 1; i >= 0; i--) {
	        var remover = removers[i];
	        if (remover === this) {
	          removers.splice(i, 1);
	          break;
	        }
	      }
	    }
	  };
	}
	
	/**
	 * Connect to event, event start and event end.
	 * @method connectContinuousEvent
	 * @param {Object} target - The target of a main event, window or document.
	 * @param {String} mainEvent - A browser event, like scroll or resize.
	 * @param {String} event - A subscribe event.
	 * @param {Object} eventOptions - An options pass to event listener
	 */
	function connectContinuousEvent(target, mainEvent, event) {
	  return function throttleEvent(throttleRate, cb, options, eventOptions) {
	    var context = options.context;
	    var domTarget = options.target;
	    var domId = domTarget && getHash(domTarget);
	    var targetPart = domId ? ':' + domId : '';
	
	    var throttledStartEvent = mainEvent + 'Start:' + throttleRate + targetPart;
	    var throttledEndEvent = mainEvent + 'End:' + throttleRate + targetPart;
	    var throttledMainEvent = mainEvent + ':' + throttleRate + targetPart;
	    var throttledEvent = event + ':' + throttleRate + targetPart;
	
	    var remover = connectThrottle(throttledEvent, cb, context, throttledMainEvent);
	    removers.push(remover);
	
	    if (listeners[throttledMainEvent]) {
	      return remover;
	    }
	
	    var ae = {
	      start: new _AugmentedEvent2.default({ mainType: mainEvent, subType: 'start' }), // start
	      main: new _AugmentedEvent2.default({ mainType: mainEvent }), // main
	      end: new _AugmentedEvent2.default({ mainType: mainEvent, subType: 'end' })
	    };
	
	    // No throttle for throttleRate = 0
	    // end
	    if (throttleRate === 'raf') {
	      throttleRate = 16; // Set as a number for setTimeout later.
	      handler = (0, _rAFThrottle2.default)(handler);
	    } else if (throttleRate > 0) {
	      handler = (0, _throttle2.default)(handler, throttleRate);
	    }
	
	    var timer = void 0;
	    function endCallback(e) {
	      ae.end.update(e);
	      EE.emit(throttledEndEvent, e, ae.end);
	      timer = null;
	    }
	    function handler(e) {
	      if (!timer) {
	        ae.start.update(e);
	        EE.emit(throttledStartEvent, e, ae.start);
	      }
	      clearTimeout(timer);
	
	      ae.main.update(e);
	      EE.emit(throttledMainEvent, e, ae.main);
	      if (!_leIE2.default) {
	        timer = setTimeout(endCallback.bind(null, e), throttleRate + _constants.EVENT_END_DELAY);
	      } else {
	        // For browser less then and equal to IE8, event object need to be cloned for setTimeout.
	        timer = setTimeout(function () {
	          endCallback((0, _clone2.default)(e));
	        }, throttleRate + _constants.EVENT_END_DELAY);
	      }
	    }
	
	    listeners[throttledMainEvent] = (0, _listen2.default)(domTarget || target, mainEvent, handler, eventOptions);
	    return remover;
	  };
	}
	
	function connectDiscreteEvent(target, event) {
	  return function throttleEvent(throttleRate, cb, options, eventOptions) {
	    var context = options.context;
	    var domTarget = options.target;
	    var domId = domTarget && getHash(domTarget);
	
	    // no throttling for discrete event
	    var throttledEvent = event + ':0' + (domId ? ':' + domId : '');
	
	    var remover = connectThrottle(throttledEvent, cb, context);
	    removers.push(remover);
	
	    if (listeners[throttledEvent]) {
	      return remover;
	    }
	
	    var ae = new _AugmentedEvent2.default({ mainType: event });
	
	    function handler(e) {
	      ae.update(e);
	      EE.emit(throttledEvent, e, ae);
	    }
	
	    listeners[throttledEvent] = (0, _listen2.default)(domTarget || target, event, handler, eventOptions);
	    return remover;
	  };
	}
	
	exports.default = {
	  scrollStart: connectContinuousEvent(win, 'scroll', 'scrollStart'),
	  scrollEnd: connectContinuousEvent(win, 'scroll', 'scrollEnd'),
	  scroll: connectContinuousEvent(win, 'scroll', 'scroll'),
	  resizeStart: connectContinuousEvent(win, 'resize', 'resizeStart'),
	  resizeEnd: connectContinuousEvent(win, 'resize', 'resizeEnd'),
	  resize: connectContinuousEvent(win, 'resize', 'resize'),
	  visibilitychange: connectDiscreteEvent(doc, 'visibilitychange'),
	  touchmoveStart: connectContinuousEvent(body, 'touchmove', 'touchmoveStart'),
	  touchmoveEnd: connectContinuousEvent(body, 'touchmove', 'touchmoveEnd'),
	  touchmove: connectContinuousEvent(body, 'touchmove', 'touchmove'),
	  touchstart: connectDiscreteEvent(body, 'touchstart'),
	  touchend: connectDiscreteEvent(body, 'touchend')
	};
	module.exports = exports['default'];


/***/ }),

/***/ 814:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _globalVars = __webpack_require__(66);
	
	var _globalVars2 = _interopRequireDefault(_globalVars);
	
	var _leIE = __webpack_require__(248);
	
	var _leIE2 = _interopRequireDefault(_leIE);
	
	var _mainEventConnectors = __webpack_require__(813);
	
	var _mainEventConnectors2 = _interopRequireDefault(_mainEventConnectors);
	
	var _constants = __webpack_require__(247);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Subscribe to UI events.
	 * @method subscribe
	 * @param {String} type - The type of event.
	 * @param {Function} cb - The callback function.
	 * @param {Object} options.context - The caller.
	 * @param {Number} options.throttleRate - The amount of time for throttling.
	 * @param {Boolean} options.useRAF - Use rAF for throttling if true.
	 * @param {Object} options.eventOptions - Option to pass to event listener
	 * @return {Object} The object with unsubscribe function.
	 */
	// less then or equal to IE8
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	
	function subscribe(type, cb) {
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	  var useRAF = options.useRAF || false;
	  var throttleRate = parseInt(options.throttleRate, 10);
	  var eventOptions = options.eventOptions;
	
	  if (isNaN(throttleRate)) {
	    throttleRate = _constants.DEFAULT_THROTTLE_RATE;
	  }
	
	  if (useRAF) {
	    throttleRate = 'raf';
	  }
	
	  // turn off throttle if the browser is IE8 or less, because window.event will be reset
	  // when using any delayed function, i.g., setTimeout, or rAF.
	  if (_leIE2.default) {
	    throttleRate = 0;
	  }
	
	  // once those variables enabled, then never disabled.
	  _globalVars2.default.enableScrollInfo = _globalVars2.default.enableScrollInfo || options.enableScrollInfo || false;
	  _globalVars2.default.enableResizeInfo = _globalVars2.default.enableResizeInfo || options.enableResizeInfo || false;
	  _globalVars2.default.enableTouchInfo = _globalVars2.default.enableTouchInfo || options.enableTouchInfo || false;
	
	  return _mainEventConnectors2.default[type](throttleRate, cb, options, eventOptions);
	}
	
	// constants
	exports.default = subscribe;
	module.exports = exports['default'];


/***/ }),

/***/ 815:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _globalVars = __webpack_require__(66);
	
	var _globalVars2 = _interopRequireDefault(_globalVars);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var removers = _globalVars2.default.removers;
	
	/**
	 * Unsubscribe to UI events.
	 * @method unsubscribe
	 * @param {String} type - The type of event.
	 * @param {Function} cb - The callback function.
	 */
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	
	function unsubscribe(type, cb) {
	  var remover = void 0;
	  for (var i = removers.length - 1; i >= 0; i -= 1) {
	    remover = removers[i];
	    if (remover._cb === cb && remover._type.indexOf(type) >= 0) {
	      remover.unsubscribe();
	      removers.splice(i, 1);
	    }
	  }
	}
	
	exports.default = unsubscribe;
	module.exports = exports['default'];


/***/ }),

/***/ 816:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	
	var listenLib = __webpack_require__(249);
	var subscribeLib = __webpack_require__(814);
	var unsubscribeLib = __webpack_require__(815);
	
	var IS_CLIENT = typeof window !== 'undefined';
	
	function warn() {
	  if (false) {
	    console.warn('Warning: the function is client-side only, does not work on server side'); // eslint-disable-line
	  }
	}
	
	module.exports = {
	  listen: IS_CLIENT ? listenLib : warn,
	  subscribe: IS_CLIENT ? subscribeLib : warn,
	  unsubscribe: IS_CLIENT ? unsubscribeLib : warn
	};


/***/ }),

/***/ 262:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = exports.PostSingle = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyImage = __webpack_require__(41);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _gatsbyLink = __webpack_require__(23);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _StyledComponents = __webpack_require__(12);
	
	var _reactStickynode = __webpack_require__(787);
	
	var _reactStickynode2 = _interopRequireDefault(_reactStickynode);
	
	var _reactScrollableAnchor = __webpack_require__(783);
	
	var _reactScrollableAnchor2 = _interopRequireDefault(_reactScrollableAnchor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	(0, _reactScrollableAnchor.configureAnchors)({
	  offset: -100,
	  scrollDuration: 400
	});
	
	var PostSingle = exports.PostSingle = function (_Component) {
	  _inherits(PostSingle, _Component);
	
	  function PostSingle() {
	    _classCallCheck(this, PostSingle);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  PostSingle.prototype.render = function render() {
	    var data = this.props.data;
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        _StyledComponents.CvWrapper,
	        null,
	        _react2.default.createElement(
	          _StyledComponents.NoPrint,
	          null,
	          _react2.default.createElement(
	            _StyledComponents.CvNav,
	            null,
	            _react2.default.createElement(
	              'h1',
	              null,
	              'C.V.'
	            ),
	            _react2.default.createElement(
	              _reactStickynode2.default,
	              { enabled: true, top: 100 },
	              data.categories.edges.map(function (_ref) {
	                var node = _ref.node;
	                return _react2.default.createElement(
	                  _StyledComponents.CvAnchor,
	                  { key: node.id, href: '#' + node.frontmatter.value },
	                  node.frontmatter.title,
	                  ' \u2192'
	                );
	              })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _StyledComponents.OnlyPrint,
	            null,
	            _react2.default.createElement(
	              'h1',
	              null,
	              data.site.siteMetadata.title,
	              ' - C.V.'
	            )
	          ),
	          data.categories.edges.map(function (_ref2) {
	            var node = _ref2.node;
	            return _react2.default.createElement(
	              _reactScrollableAnchor2.default,
	              { key: node.id, id: node.frontmatter.value },
	              _react2.default.createElement(
	                _StyledComponents.CvContainer,
	                null,
	                _react2.default.createElement(
	                  _StyledComponents.CvCategory,
	                  null,
	                  node.frontmatter.title
	                ),
	                data.items.edges.filter(function (cvItem) {
	                  return cvItem.node.frontmatter.category.toLowerCase() === node.frontmatter.value.toLowerCase();
	                }).map(function (cvItem) {
	                  return _react2.default.createElement(
	                    _StyledComponents.CvItem,
	                    { key: cvItem.node.id },
	                    cvItem.node.frontmatter.file !== "" && cvItem.node.frontmatter.file !== undefined && cvItem.node.frontmatter.file !== null ? _react2.default.createElement(
	                      _StyledComponents.CvLink,
	                      { href: cvItem.node.frontmatter.file },
	                      _react2.default.createElement(
	                        _StyledComponents.CvTitle,
	                        null,
	                        cvItem.node.frontmatter.title
	                      )
	                    ) : _react2.default.createElement(
	                      _StyledComponents.CvTitle,
	                      null,
	                      cvItem.node.frontmatter.title
	                    ),
	                    cvItem.node.frontmatter.category.toLowerCase() !== 'education' && _react2.default.createElement(
	                      _StyledComponents.CvDate,
	                      null,
	                      cvItem.node.frontmatter.start_date !== null && cvItem.node.frontmatter.start_date !== undefined && cvItem.node.frontmatter.start_date !== "" && _react2.default.createElement(
	                        'span',
	                        null,
	                        cvItem.node.frontmatter.start_date
	                      ),
	                      cvItem.node.frontmatter.start_date && (cvItem.node.frontmatter.end_date || cvItem.node.frontmatter.current) && _react2.default.createElement(
	                        'span',
	                        null,
	                        '\xA0\u2014\xA0'
	                      ),
	                      cvItem.node.frontmatter.end_date !== null && cvItem.node.frontmatter.end_date !== undefined && cvItem.node.frontmatter.end_date !== "" && _react2.default.createElement(
	                        'span',
	                        null,
	                        cvItem.node.frontmatter.end_date
	                      ),
	                      cvItem.node.frontmatter.current && _react2.default.createElement(
	                        'span',
	                        null,
	                        'Current'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _StyledComponents.CvPlace,
	                      null,
	                      cvItem.node.frontmatter.place
	                    ),
	                    _react2.default.createElement(
	                      _StyledComponents.NoPrint,
	                      null,
	                      _react2.default.createElement(_StyledComponents.CvContent, {
	                        dangerouslySetInnerHTML: {
	                          __html: cvItem.node.html
	                        }
	                      })
	                    )
	                  );
	                })
	              )
	            );
	          })
	        )
	      )
	    );
	  };
	
	  return PostSingle;
	}(_react.Component);
	
	exports.default = PostSingle;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-resume-js-743eb0f536dc1cae987a.js